import { InjectionToken } from '@angular/core';

/** Base URL of the Stages public viewer; the apartment's `stagesProjectPublicLink` is appended to it. */
export const STAGES_PUBLIC_URL = new InjectionToken<string>('STAGES_PUBLIC_URL');
